import React from 'react';
import { Row, Col } from 'reactstrap';
import IndustryOverview1 from 'pages/Dashboard/IndustryOverview1';
import ObservedInd1 from 'pages/Dashboard/ObservedInd1';
import IndusBenchMark1 from '../echart1/IndusBenchMark1';
const IndexBenchMarking1 = () => {
    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid mt-4">
                    <h3>Motorcycle Dealers in Australia</h3>
                    <Row>
                        <Col lg="8">
                          <IndusBenchMark1/>
                        </Col>
                        <Col lg="4">
                        <ObservedInd1/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <IndustryOverview1/>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
};

export default IndexBenchMarking1;
